/* eslint-disable import/no-anonymous-default-export */
import _ from 'lodash';

const initialState = 1;

export default (state = initialState, action) => {

  if (action.type === 'INCREMENT_PAGE_ASSETS') {

    return state + 1;
  }

  if (
    [
      'RESET_PAGE_ASSETS',
      'ADD_FILTER_ASSETS',
      'DELETE_FILTER_ASSETS',
      'RESET_FILTERS_ASSETS',
      'SET_FILTERS_ASSETS',
    ].includes(action.type)
  ) {
    return 1;
  }

  // -----------------------------------------  Reset the state when the user logs out ------------------------------------------
  if (action.type === 'LOGOUT_USER') {
    return initialState;
  }

  return state;
};